import { render, staticRenderFns } from "./companyInvitationApproval.vue?vue&type=template&id=70690933&"
import script from "./companyInvitationApproval.vue?vue&type=script&lang=js&"
export * from "./companyInvitationApproval.vue?vue&type=script&lang=js&"
import style0 from "./companyInvitationApproval.vue?vue&type=style&index=0&id=70690933&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports